import React from 'react';
import Header from 'components/Admin/shared/Table/Header.jsx';

const titles = {
  start_date: 'CREATED DATE/TIME',
  title: 'TITLE',
  namespace: 'NAMESPACE'
};

const additionalProps = {};

function Headers({
  onChange,
  value: selectedValue
}) {
  return (
      <tr>
        <th></th>
        {Object.keys(titles).map(value => (
            <Header
              onChange={onChange}
              key={value}
              values={[value]}
              title={titles[value]}
              selected={selectedValue}
              {...(additionalProps[value]) || {}}
            />
        ))}
      </tr>
  );
}

Headers.defaultProps = {};

Headers.propTypes = {};

export default Headers;



/** WEBPACK FOOTER **
 ** ./src/components/Admin/Sponsor/List/Headers.jsx
 **/